
import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';
import Layout from '../../Layout/CustomerLayout.js';
import * as General from '../General/General.js';
import * as ReactDOM from 'react-router-dom';
import PN from 'persian-number'
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import { BiFilter } from "react-icons/bi";
import AddBasketItem from "../Basket/AddBasketItem.js"
import { trackPromise } from 'react-promise-tracker';
// import * as BiIcon from "react-icons/bi"
import axios from 'axios';
import { BasketContext } from "../Context/BasketContext.js";
import Drp_PickerCity from '../ProvinceCity/Drp_PickerCity.js';

const Basket = () => {

    const toaster = rsuite.useToaster();
    const CityRef = useRef()

    // const [BasketItemList, setBasketItemList] = React.useState([]);
    // const { setCount } = React.useContext(BasketContext); // 👈 اینجاست
    // const [TotalPrice, setTotalPrice] = React.useState(0)
    const {
        BasketItemList,
        setBasketItemList,
        TotalPrice,
        setTotalPrice,
        count,
        setCount,
        basketRef
    } = React.useContext(BasketContext);
    const [Open, setOpen] = React.useState(false);
    const [Address, setAddress] = React.useState("")
    const [PostalCode, setPostalCode] = React.useState("")
    const [CityId, setCityId] = React.useState("-1")
    const [ProvinceId, setProvinceId] = React.useState("-1")
    const [BasketId, setBasketId] = React.useState(General.GuidEmpty())
    const [BasketCode, setBasketCode] = React.useState()

    const Bind = () => {
        var RequestOptions = {
            data: {
            },
            url: General.ApiRoute() + "/Basket/Basket_GetByCustomerId",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json',
                "CustomerId": localStorage.getItem("CustomerFarmAsanId")

            }
        }
        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    var tmp = [];
                    var itemCount = 0;
                    if (result.data.children.length > 0) {
                        setBasketId(result.data.id)
                        setBasketCode(result.data.code)

                        for (var i = 0; i < result.data.children.length; i++) {
                            itemCount = itemCount + result.data.children[i].count
                            tmp.push({
                                row: i + 1,
                                Id: result.data.children[i].id,
                                ProductId: result.data.children[i].productId,
                                StoreRoomInventoryId: result.data.children[i].storeRoomInventoryId,
                                Product: result.data.children[i].product,
                                Title: result.data.children[i].title,
                                Group: result.data.children[i].group,
                                Parent: result.data.children[i].parent,
                                Count: result.data.children[i].count,
                                Unit: result.data.children[i].unit,
                                TotalPrice: result.data.children[i].totalPrice,
                                Price: result.data.children[i].price,
                                Tax: result.data.children[i].tax,
                                SaleType: result.data.children[i].saleType,
                                DiscountPrice: result.data.children[i].discountPrice,
                                DiscountPercent: result.data.children[i].discountPercent,
                                PhotoUrl: result.data.children[i].photos.length > 0 ? General.ApiPhotoRoute() + 'Content/Images/Product/Photo/' + result.data.children[i].photos[0].photoURLName : '',
                            })

                        }
                        setBasketItemList([...tmp]);
                        setCount(itemCount)
                        setTotalPrice(result.data.totalPrice)

                        if (result.data.address.includes("|PostCode:")) {
                            setAddress(result.data.address.split("|PostCode:")[0])
                            setPostalCode(result.data.address.split("|PostCode:")[1])
                            CityRef.current.Bind(result.data.cityId)
                            setCityId(result.data.cityId)
                        }
                        else {
                            GetAddress();
                        }
                    }



                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )

    }



    const GetAddress = () => {
        trackPromise(
            fetch(General.ApiRoute() + '/User/GetByIdForWeb', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'Id': localStorage.getItem("CustomerFarmAsanId")
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    setAddress(result.address);
                    setCityId(result.cityId);
                    setProvinceId(result.provinceId);
                    setPostalCode(result.postalCode);
                    CityRef.current.Bind(result.cityId == -1 ? 0 : result.cityId)
                })
        )
    }


    const UpdateAddress = () => {
        if (Address == "" || PostalCode == "" || CityId == 0 || CityId == -1) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("اطلاعات آدرس را کامل وارد کنید")), 'topCenter')
            return;
        }
        var RequestOptions = {
            data: {
                "FirstName": localStorage.getItem("UserFullNameFarmAsan"),
                "Address": Address,
                "CityId": CityId,
                "ProvinceId": ProvinceId,
                "PostalCode": PostalCode,
                "Id": localStorage.getItem("CustomerFarmAsanId"),
            },
            url: General.ApiRoute() + "/User/UpdateAddress",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json',
                'BasketId': BasketId
            }
        }
        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    if (result.data.includes("OK")) {
                        toaster.push(General.ShowMessage('success', General.SuccessMessage(" آدرس با موفقیت ثبت گردید . ")), 'topCenter')
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')
                    }

                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }




    const ShowProduct = (id, title, Parent, Group) => {
        localStorage.setItem("ProductId", id);
        localStorage.setItem("ByBrand", false);
        localStorage.setItem("BySuggestion", false);
        localStorage.setItem("ByCompare", false);

        var parent = General.toSlug(Parent, { latin: true })
        var group = General.toSlug(Group, { latin: true })
        var product = General.toSlug(title, { latin: true })

        var NewGroup = group != parent ? group.replace(parent, "").replace(/-+/g, "-").replace(/^-+|-+$/g, "") : group;
        var Newproduct = product.replace(parent, "").replace(NewGroup, "").replace(/-+/g, "-").replace(/^-+|-+$/g, "") == "" ? product :
            product.replace(parent, "").replace(NewGroup, "").replace(/-+/g, "-").replace(/^-+|-+$/g, "");
        window.location.href = '/ProductInfo/' + parent + "/" + NewGroup + "/" + Newproduct;


    }

    const Payment = async () => {
        // localStorage.setItem("payType", 'irfMgu_FOoMbGPqmKYpnkl_nIOIsavagzESWyD0tHg0')

        var RequestOptions = {
            data: {
                Id: BasketId,
                TotalPrice: TotalPrice,
                Code: BasketCode
            },
            url: General.ApiRoute() + "/FinalPayment/RequestPayment",
            // url: General.ApiRoute() + "/FinalPayment/Verify",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json',
                // 'Id': BasketId,
                // 'TotalPrice': TotalPrice,
                // 'Code': BasketCode
            }
        }

        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                  
                  
                    if (result.data.success) {

                        const form = document.createElement("form");
                        form.method = "POST";
                        form.action = "https://omid.shaparak.ir/_ipgw_/MainTemplate/payment/";
                        
                        const token = document.createElement("input");
                        token.type = "hidden";
                        token.name = "token";
                        token.value = result.data.token;

                        const language = document.createElement("input");
                        language.type = "hidden";
                        language.name = "language";
                        language.value = "fa";

                        form.appendChild(token);
                        form.appendChild(language);

                        document.body.appendChild(form);
                        form.submit();
                    }


                    else {

                        toaster.push(
                            General.ShowMessage(
                                'error',
                                General.ErrorMessage("خطا در دریافت لینک پرداخت")
                            ),
                            'topCenter'
                        );

                    }

                })
                .catch((error) => {

                    console.dir(error)
                    console.dir(error.response)
                    console.dir(error.response.data)


                    console.log(error)
                    console.dir(error.response)
                    console.dir(error.response.data)

                    toaster.push(
                        General.ShowMessage(
                            'error',
                            General.ErrorMessage(
                                error?.response?.data || "خطا در اتصال به درگاه"
                            )
                        ),
                        'topCenter'
                    );

                })
        );
    }




    React.useEffect(() => {
        Bind();
        // GetAddress();


    }, [])


    return (
        <Layout title={'سبد خرید- ' + localStorage.getItem("UserFullNameFarmAsan")} >

            <rsuite.Row className="p-3">

                <rsuite.Col xs={24} sm={24} md={15}>
                    <rsuite.Row className="justify-content-center align-items-center ">

                        {BasketItemList.map(item => (
                            <rsuite.Col xs={24} className=" border rounded-2 border-2 mb-2">

                                <rsuite.Panel bodyFill >
                                    <rsuite.Row>
                                        <rsuite.Col xs={7} className="m-0 p-0">
                                            <rsuite.Image
                                                src={item.PhotoUrl}
                                                fallbackSrc="../../../../assets/images/ProductGroupPrefer.jpg"
                                                style={{ width: '150px', height: '170px' }}
                                                className="border-radius-half Cursor text-end"
                                            />
                                        </rsuite.Col>
                                        <rsuite.Col xs={17} className="m-0 p-0" >

                                            <rsuite.Card.Body >
                                                <rsuite.Row className='mt-2'>
                                                    <rsuite.Col xs={24} className=' text-end'>
                                                        <button type="button" onClick={() => ShowProduct(item.ProductId, item.Product, item.Parent, item.Group)} class="btn btn-link FarmAsan-text">
                                                            <b> {item.Title} (مشاهده محصول ...) </b>
                                                        </button>

                                                    </rsuite.Col>
                                                    <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='p-2 text-end'>
                                                        <b> تعداد: </b> {item.Count} {item.Unit}
                                                    </rsuite.Col>
                                                    <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='p-2 text-end'>
                                                        <b>  قیمت واحد : </b> {PN.sliceNumber(item.Price)} ریال
                                                    </rsuite.Col>
                                                    <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='p-2 text-end'>
                                                        <b>  مالیات  : </b> {PN.sliceNumber(item.Tax)} ریال
                                                    </rsuite.Col>
                                                    <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='p-2 text-end'>
                                                        <b>  تخفیف  : </b> {PN.sliceNumber(item.DiscountPrice)} ریال
                                                    </rsuite.Col>
                                                    <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='p-2 text-end'>
                                                        <b>  قیمت کل : </b> {PN.sliceNumber(item.TotalPrice)} ریال
                                                    </rsuite.Col>
                                                    <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className={item.SaleType == 2 ? 'p-2 text-end' : "hide"}>
                                                        <span className="text-success text-decoration-underline fw-bold">رزرو شده است</span>

                                                    </rsuite.Col>
                                                    <rsuite.Col xs={24} className='ms-4 ps-4 text-start mb-2 ' >
                                                        <AddBasketItem className="Group" value={item.ProductId + "|" + item.Title + "|1|" + item.StoreRoomInventoryId + "|" + item.Price + "|" + item.SaleType + "|" + item.Count + "|" + item.Id} />
                                                    </rsuite.Col>


                                                </rsuite.Row>
                                            </rsuite.Card.Body>

                                        </rsuite.Col>
                                    </rsuite.Row>

                                </rsuite.Panel>
                            </rsuite.Col>

                        ))}

                    </rsuite.Row>

                </rsuite.Col>
                <rsuite.Col xs={24} sm={24} md={9} >

                    {BasketItemList.length > 0 ?
                        <rsuite.Col xs={24} className=" border rounded-2 border-2 mb-2 FarmAsan-bg p-3">
                            <rsuite.Row>
                                <rsuite.Card.Body >
                                    <rsuite.Row className='mt-2 '>

                                        <rsuite.Col xs={24} className='p-2 text-end'>
                                            <b> تعداد اقلام فاکتور : </b> {BasketItemList.map(o => o.Count).reduce((a, b) => a + b)}
                                        </rsuite.Col>
                                        <rsuite.Col xs={24} className={BasketItemList.map(o => o.Tax).reduce((a, b) => a + b) > 0 ? 'p-2 text-end' : 'hide'}>
                                            <b>  قیمت کل  : </b>  {PN.sliceNumber(BasketItemList.map(o => o.Price * o.Count).reduce((a, b) => a + b))}  ریال<br />
                                            <rsuite.Text className="text-light" as='sub'>{PN.convert(BasketItemList.map(o => o.Price * o.Count).reduce((a, b) => a + b).toString().replaceAll(',', ''))} ریال</rsuite.Text>

                                        </rsuite.Col>
                                        <rsuite.Col xs={24} className={BasketItemList.map(o => o.Tax).reduce((a, b) => a + b) > 0 ? 'p-2 text-end' : 'hide'}>
                                            <b>  مالیات  : </b>  {PN.sliceNumber(BasketItemList.map(o => o.Tax * o.Count).reduce((a, b) => a + b))}  ریال<br />
                                            <rsuite.Text className="text-light" as='sub'>{PN.convert(BasketItemList.map(o => o.Tax * o.Count).reduce((a, b) => a + b).toString().replaceAll(',', ''))} ریال</rsuite.Text>

                                        </rsuite.Col>
                                        <rsuite.Col xs={24} className={BasketItemList.map(o => o.DiscountPrice).reduce((a, b) => a + b) > 0 ? 'p-2 text-end' : 'hide'}>
                                            <b>  قیمت قبل از تخفیف : </b>
                                            {PN.sliceNumber(BasketItemList.map(o => (o.Tax + o.Price) * o.Count).reduce((a, b) => a + b))}  ریال<br />
                                            <rsuite.Text className="text-light" as='sub'>{PN.convert(BasketItemList.map(o => (o.Tax + o.Price) * o.Count).reduce((a, b) => a + b).toString().replaceAll(',', ''))} ریال</rsuite.Text>

                                        </rsuite.Col>

                                        <rsuite.Col xs={24} className={BasketItemList.map(o => o.DiscountPrice).reduce((a, b) => a + b) > 0 ? 'p-2 text-end' : 'hide'}>
                                            <b>  تخفیف  : </b>  {PN.sliceNumber(BasketItemList.map(o => o.DiscountPrice * o.count).reduce((a, b) => a + b))}  ریال<br />
                                            <rsuite.Text className="text-light" as='sub'>{PN.convert(BasketItemList.map(o => o.DiscountPrice * o.Count).reduce((a, b) => a + b).toString().replaceAll(',', ''))} ریال</rsuite.Text>

                                        </rsuite.Col>
                                        <rsuite.Col xs={24} className='p-2 text-end'>
                                            <rsuite.Divider></rsuite.Divider>
                                            <b>  مبلغ قابل پرداخت : </b>  {PN.sliceNumber(TotalPrice)}  ریال<br />
                                            <rsuite.Text className="text-light" as='sub'>{PN.convert(TotalPrice.toString().replaceAll(',', ''))} ریال</rsuite.Text>

                                        </rsuite.Col>



                                    </rsuite.Row>
                                </rsuite.Card.Body>



                            </rsuite.Row>
                        </rsuite.Col>
                        :
                        <></>
                    }

                    <rsuite.Col xs={24} className=" border rounded-2 border-2 mb-2 FarmAsan-bg p-3">
                        <rsuite.Row>
                            <rsuite.Card.Body >
                                <rsuite.Row className='mt-2 '>
                                    <rsuite.Col xs={24} className='p-2 text-end'>
                                        <rsuite.InputGroup inside >
                                            <rsuite.InputGroup.Addon className=" border-2 border-top-0 border-bottom-0 border-end-0 border-start">شهر</rsuite.InputGroup.Addon>
                                            <Drp_PickerCity value={CityId} onChange={(cityId, provinceId, title) => (setCityId(cityId), setProvinceId(provinceId))} ref={CityRef} />
                                        </rsuite.InputGroup>
                                    </rsuite.Col>
                                    <rsuite.Col xs={24} className='p-2 text-end'>
                                        <rsuite.InputGroup inside >
                                            <rsuite.InputGroup.Addon className=" border-2 border-top-0 border-bottom-0 border-end-0 border-start">کد پستی</rsuite.InputGroup.Addon>
                                            <rsuite.Input value={PostalCode} onChange={(e) => setPostalCode(e)}></rsuite.Input>
                                        </rsuite.InputGroup>
                                    </rsuite.Col>
                                    <rsuite.Col xs={24} className='p-2 text-end'>
                                        <rsuite.InputGroup inside >
                                            <rsuite.InputGroup.Addon className=" border-2 border-top-0 border-bottom-0 border-end-0 border-start">آدرس</rsuite.InputGroup.Addon>
                                            <rsuite.Input as='textarea' rows="4" value={Address} onChange={(e) => setAddress(e)}></rsuite.Input>
                                        </rsuite.InputGroup>
                                    </rsuite.Col>
                                    <rsuite.Col xs={24} className="pe-2 ps-2">
                                        <rsuite.Button onClick={() => UpdateAddress()} color="red" className="border border-2  ml-3  Font17" size="lg" style={{ color: "#ffff" }} block appearance="subtle">
                                            ثبت آدرس گیرنده
                                        </rsuite.Button>
                                    </rsuite.Col >
                                </rsuite.Row>
                            </rsuite.Card.Body>
                        </rsuite.Row>
                    </rsuite.Col>

                    <rsuite.Col xs={24} >
                        <rsuite.Button className='FarmAsan-success  pt-5 pb-5'
                            onClick={() => Payment()}
                            appearance="primary" block disabled={Address == "" || CityId == -1 || PostalCode == "" ? true : false} > <b className="Font17">
                                {Address == "" || CityId == -1 || PostalCode == "" ? <>اطلاعات آدرس را تکمیل کنید</> : <>پرداخت</>}
                            </b> </rsuite.Button>
                    </rsuite.Col>
                </rsuite.Col>
            </rsuite.Row>
        </Layout >
    )
}

export default Basket;